const {NODE_ENV, REACT_APP_INSTANCE_ID} = (window as any).env;

export const getDomainName = () => {
  const {hostname} = window.location;
  if (hostname === 'localhost' && NODE_ENV === 'development') {
    return REACT_APP_INSTANCE_ID;
  }
  return hostname.split('.')[0];
};
